export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于我们</h2>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-8">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-fire-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="text-xl font-heading font-bold text-foreground-900 mb-4">吃瓜官网 — 专业娱乐资讯平台</h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              吃瓜官网成立于2020年，是国内领先的娱乐资讯与八卦爆料聚合平台。我们拥有一支资深的娱乐编辑团队，7×24小时不间断追踪娱乐圈最新动态，从明星恋情到综艺内幕，从影视吐槽到饭圈观察，为亿万网友提供及时、全面、深度的娱乐内容。作为51吃瓜官网官方入口，我们始终致力于打造安全可靠的吃瓜社区，让每一位用户都能在这里找到属于自己的娱乐方式。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
              平台坚持独立客观的内容态度，既不做无底线的炒作，也不刻意回避敏感话题。我们的目标是成为中文互联网最值得信赖的娱乐资讯入口，让吃瓜变成一件有趣又有料的事。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}